import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import 'maplibre-gl/dist/maplibre-gl.css';
import L from "leaflet";
import '@maplibre/maplibre-gl-leaflet';
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import { colors } from '../color';
import { PlusOutlined } from '@ant-design/icons';
import { FaCrosshairs } from 'react-icons/fa';
import { ServerIP, ServerSocketIP } from '../component/ServerIP';
import { io } from 'socket.io-client';
import { AlertFilled, AlertOutlined } from '@ant-design/icons';




const DriverShareMap = () => {

    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('orderId');
    const driverId = params.get('driverId');

    // États pour les informations de la mission
    const [missionData, setMissionData] = useState(null);
    const [driverData, setDriverData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [isWebSocketConnected, setIsWebSocketConnected] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);

    // Refs pour Socket.io et marqueurs
    const socketRef = useRef(null);
    const userMarker = useRef(null);
    const fallbackIntervalRef = useRef(null);
    const isCleaningUpRef = useRef(false);

    //Map
    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.6565184, lng: -72.3156992 };
    const [location, setLocation] = useState({});

    const [zoom] = useState(12);


    useEffect(() => {
        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
            minZoom: 3,
        });


        // Utilisation de MapLibre GL avec Leaflet selon la documentation OpenFreeMap
        L.maplibreGL({
            style: 'https://tiles.openfreemap.org/styles/liberty',
            attribution: '© <a href="https://openfreemap.org/copyright">OpenFreeMap</a> contributors'
        }).addTo(map.current);

        fetchNearbyMarker();

    }, [center.lat, center.lng, zoom]);

    //Alert

    const userMarkerRef = useRef(null);
    const [alertMarker, setAlertMarker] = useState([]);
    const [oldAlertMarker, setOldAlertMarker] = useState([])
    const [showMarker, setShowMarker] = useState(true);

    function getColor(title) {
        switch (title) {
            case 'Tir':
                return 'rgba(255,0,0,0.5)';
            case 'Kidnapping':
                return 'rgba(230, 126, 34, 0.5)';
            case 'Blocked':
                return 'gray';
            default:
                return 'black';
        }
    }

    function getIcon(title) {
        switch (title) {
            case 'Tir':
                return L.icon({ iconUrl: require('../data/IconImageMap/gun.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Kidnapping':
                return L.icon({ iconUrl: require('../data/IconImageMap/child.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Blocked':
                return L.icon({ iconUrl: require('../data/IconImageMap/block1.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            default:
                return L.icon({ iconUrl: require('../data/IconImageMap/block.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
        }
    }

    function getRadius(title) {
        switch (title) {
            case 'Tir':
                return 400;
            case 'Kidnapping':
                return 600;
            case 'Blocked':
                return 100;
            default:
                return 100;
        }
    }

    const markersRef = useRef([]);
    const circlesRef = useRef([]);

    useEffect(() => {
        if (Array.isArray(alertMarker) && alertMarker.length > 0) {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];

            alertMarker.map((marker, index) => {
                if (marker.coordinate) {
                    const icon = getIcon(marker.title);
                    const markerInstance = L.marker([marker.coordinate.latitude, marker.coordinate.longitude], { icon }).addTo(map.current);
                    markerInstance.bindPopup(`${marker.title} - ${getTime(marker.createdAt)}`);

                    markerInstance.on('click', () => {
                        map.current.flyTo([marker.coordinate.latitude, marker.coordinate.longitude], map.current.getZoom());
                    });

                    const circle = L.circle([marker.coordinate.latitude, marker.coordinate.longitude], { radius: getRadius(marker.title), fillColor: getColor(marker.title), fillOpacity: 0.2, color: getColor(marker.title) }).addTo(map.current);

                    // Ajoutez les instances de marqueurs et de cercles aux tableaux
                    markersRef.current.push(markerInstance);
                    circlesRef.current.push(circle);
                }
            });
        }
    }, [alertMarker]);


    const fetchNearbyMarker = async () => {

        await axios.get(`${ServerIP}/alert/getAlert`)
            .then(res => {
                setAlertMarker(res.data.alertMarker)
                setOldAlertMarker(res.data.alertMarker)
            })
    };

    const cancelShowMarker = () => {
        setShowMarker(false);
        setAlertMarker([])
    }

    const showMarkerFunc = () => {
        setShowMarker(true);
        setAlertMarker(oldAlertMarker);
    }



    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }
    }




    //Coordinate

    // Fonction de fallback utilisant les APIs existantes
    const fetchDataWithFallback = async () => {
        try {
            // Ne pas utiliser le fallback si WebSocket est connecté et fonctionne
            if (isWebSocketConnected) {
                console.log('🚫 Fallback API ignoré - WebSocket connecté et fonctionnel');
                return;
            }
            
            setLoading(true);
            setError(null);
            console.log('📡 Utilisation fallback API - WebSocket non disponible');

            // Utiliser les APIs de fallback existantes
            const [missionResponse, driverResponse] = await Promise.all([
                axios.get(`${ServerIP}/mission/getOneMissions/${orderId}`),
                axios.get(`${ServerIP}/driver/getProfileDriver/${driverId}`)
            ]);

            // Seulement mettre à jour si WebSocket n'est toujours pas connecté
            if (!isWebSocketConnected) {
                if (missionResponse.data.mission) {
                    setMissionData(missionResponse.data.mission);
                    console.log('📋 Données mission mises à jour via fallback API');
                }

                if (driverResponse.data.driver) {
                    setDriverData(driverResponse.data.driver);
                    console.log('👤 Données chauffeur mises à jour via fallback API');
                    // Mettre à jour la position si disponible
                    if (driverResponse.data.driver.latitude && driverResponse.data.driver.longitude) {
                        setLocation({
                            latitude: driverResponse.data.driver.latitude,
                            longitude: driverResponse.data.driver.longitude,
                            name: driverResponse.data.driver.name || 'Chauffeur'
                        });
                        setLastUpdate(new Date());
                    }
                }
            }

            setLoading(false);
            console.log('✅ Données récupérées via APIs de fallback');

        } catch (err) {
            console.error('❌ Erreur APIs de fallback:', err);
            setError('Impossible de charger les informations du trajet');
            setLoading(false);
        }
    };

    // Récupérer les données de la mission et du chauffeur
    useEffect(() => {
        if (orderId && driverId) {
            // Essayer d'abord le fallback API
            fetchDataWithFallback();
        }
    }, [orderId, driverId]);

    useEffect(() => {
        let fallbackInterval = null;
        
        // Fonction de nettoyage des événements
        const cleanupSocketEvents = () => {
            if (socketRef.current) {
                socketRef.current.off('connect');
                socketRef.current.off('disconnect');
                socketRef.current.off('connect_error');
                socketRef.current.off('receiveOptimizedDriverData');
            }
            if (fallbackInterval) {
                clearInterval(fallbackInterval);
                fallbackInterval = null;
            }
        };

        // Nettoyer les anciens événements avant d'en créer de nouveaux
        cleanupSocketEvents();

        // Connexion Socket.IO avec gestion d'erreurs
        if (!socketRef.current) {
            console.log('🔄 Initialisation nouvelle connexion WebSocket...');
            socketRef.current = io(ServerSocketIP, {
                withCredentials: true,
                transports: ["websocket", "polling"],
                timeout: 10000,
                forceNew: true
            });
        } else if (socketRef.current.connected) {
            // Si déjà connecté, rejoindre directement la room
            console.log('🔄 Utilisation connexion WebSocket existante');
            socketRef.current.emit('joinRoomDriver', { driverId, orderId });
            setIsWebSocketConnected(true);
        }

        // Gestion de la connexion WebSocket
        socketRef.current.on('connect', () => {
            console.log('✅ WebSocket connecté avec succès');
            setIsWebSocketConnected(true);
            setError(null);
            
            // Nettoyer l'interval de fallback si il existe
            if (fallbackInterval) {
                clearInterval(fallbackInterval);
                fallbackInterval = null;
            }
            
            // Rejoindre la room spécifique
            socketRef.current.emit('joinRoomDriver', { driverId, orderId });
            console.log('🏠 Rejoint la room:', { driverId, orderId });
        });

        socketRef.current.on('disconnect', (reason) => {
            console.log('❌ WebSocket déconnecté:', reason);
            setIsWebSocketConnected(false);
            
            // Utiliser le fallback API toutes les 15 secondes si WebSocket déconnecté
            if (!fallbackInterval) {
                console.log('🔄 Activation du mode fallback API');
                fallbackInterval = setInterval(() => {
                    if (!socketRef.current?.connected) {
                        console.log('📡 Récupération données via fallback API...');
                        fetchDataWithFallback();
                    } else {
                        console.log('✅ WebSocket reconnecté, arrêt du fallback');
                        clearInterval(fallbackInterval);
                        fallbackInterval = null;
                    }
                }, 15000);
            }
        });

        socketRef.current.on('connect_error', (error) => {
            console.error('❌ Erreur de connexion WebSocket:', error.message);
            setIsWebSocketConnected(false);
            setError('Erreur de connexion WebSocket');
            
            // Utiliser immédiatement le fallback API
            console.log('🚨 Utilisation immédiate du fallback API');
            fetchDataWithFallback();
        });

        // Écouter le nouvel événement optimisé pour mobile
        socketRef.current.on('receiveOptimizedDriverData', (data) => {
            console.log('📱 Données optimisées reçues via WebSocket:', {
                hasData: !!data,
                hasPosition: !!(data?.latitude && data?.longitude),
                driverName: data?.name,
                missionStatus: data?.mission?.status,
                livraisonStatus: data?.mission?.livraisonStatus,
                timestamp: new Date().toISOString()
            });
            
            // Validation des données reçues
            if (data?.mission && orderId && data.mission.orderId !== orderId) {
                console.warn('⚠️ Incohérence détectée côté client:', {
                    expectedOrderId: orderId,
                    receivedOrderId: data.mission.orderId,
                    message: 'Les données reçues ne correspondent pas à la mission demandée'
                });
                return; // Ignorer les données incohérentes
            }

            if (data && data.latitude && data.longitude) {
                // Mettre à jour la position
                setLocation({
                    latitude: parseFloat(data.latitude),
                    longitude: parseFloat(data.longitude),
                    name: data.name || 'Chauffeur'
                });
                setLastUpdate(new Date(data.lastUpdate) || new Date());

                // Mettre à jour les données du chauffeur (optimisées)
                setDriverData({
                    name: data.name || 'Chauffeur inconnu',
                    phone: data.phone || 'Non disponible',
                    vehicule: data.vehicule || 'Non spécifié',
                    rating: data.rating || 0,
                    connected: data.connected || false
                });

                // Mettre à jour les données de la mission si disponibles
                if (data.mission) {
                    setMissionData({
                        orderId: data.mission.orderId,
                        type: data.mission.type,
                        livraisonStatus: data.mission.livraisonStatus,
                        pickupAddress: data.mission.pickupAddress,
                        deliveredAddress: data.mission.deliveredAddress,
                        status: data.mission.status,
                        startMission: data.mission.startMission,
                        createdAt: data.mission.createdAt
                    });
                }

                // Marquer comme chargé
                setLoading(false);
                setError(null);
                setIsWebSocketConnected(true);

                console.log('✅ Données mises à jour via WebSocket:', {
                    driver: data.name,
                    status: data.mission?.status || 'Aucune mission',
                    position: `${data.latitude}, ${data.longitude}`,
                    timestamp: new Date().toLocaleTimeString()
                });
            } else {
                console.error('❌ Données WebSocket incorrectes ou incomplètes:', {
                    hasData: !!data,
                    hasLatitude: !!data?.latitude,
                    hasLongitude: !!data?.longitude,
                    data: data
                });
            }
        });

        // Fonction de nettoyage
        return () => {
            console.log('🧹 Nettoyage des événements WebSocket');
            cleanupSocketEvents();
        };
    }, [driverId, orderId]);


    // Mise à jour du marqueur de position reçue via socket
    useEffect(() => {
        if (location.latitude && location.longitude) {
            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 35],
            });

            if (!userMarker.current) {
                userMarker.current = L.marker([location.latitude, location.longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarker.current.setLatLng([location.latitude, location.longitude]);
            }
        }
    }, [location]);


    // Fonction pour formater l'heure
    const formatTime = (date) => {
        if (!date) return 'Non disponible';
        return new Date(date).toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    // Fonction pour formater la date
    const formatDate = (date) => {
        if (!date) return 'Non disponible';
        return new Date(date).toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Fonction pour obtenir le texte du statut de mission
    const getMissionStatusText = (mission) => {
        if (!mission) return 'Statut inconnu';
        
        // Si la mission est annulée
        if (mission.cancelled) {
            return 'Mission annulée';
        }
        
        // Pour les livraisons
        if (mission.type === 'Livraison') {
            if (mission.livraisonStatus) {
                // Si la mission a un statut de livraison spécifique
                switch (mission.livraisonStatus) {
                    case 'Accepté':
                        return 'Commande acceptée';
                    case 'Prise en charge':
                        return 'Colis récupéré';
                    case 'En route':
                        return 'En cours de livraison';
                    case 'Livré':
                        return 'Livraison terminée';
                    default:
                        return mission.livraisonStatus;
                }
            } else {
                // Fallback sur startMission pour les livraisons sans livraisonStatus
                return mission.startMission ? 'Livraison en cours' : 'En attente de départ';
            }
        }
        
        // Pour les transports
        if (mission.type === 'Transport') {
            if (mission.reservationStatus && mission.isReserved) {
                // Pour les réservations
                switch (mission.reservationStatus) {
                    case 'Confirmée':
                        return mission.startMission ? 'Transport en cours' : 'Réservation confirmée';
                    case 'Annulée':
                        return 'Réservation annulée';
                    case 'En attente':
                        return 'Réservation en attente';
                    default:
                        return mission.reservationStatus;
                }
            } else {
                // Transport normal
                if (mission.payedDriverConfirmation) {
                    return 'Transport terminé';
                } else if (mission.startMission) {
                    return 'Transport en cours';
                } else {
                    return 'En attente de départ';
                }
            }
        }
        
        // Fallback général
        return mission.startMission ? 'En cours' : 'En attente';
    };
    
    // Fonction pour obtenir la couleur du statut de mission
    const getMissionStatusColor = (mission) => {
        if (!mission) return '#6b7280'; // Gris pour inconnu
        
        // Si la mission est annulée
        if (mission.cancelled) {
            return '#dc2626'; // Rouge pour annulé
        }
        
        // Pour les livraisons
        if (mission.type === 'Livraison') {
            if (mission.livraisonStatus) {
                switch (mission.livraisonStatus) {
                    case 'Accepté':
                        return '#2563eb'; // Bleu pour accepté
                    case 'Prise en charge':
                        return '#ea580c'; // Orange pour prise en charge
                    case 'En route':
                        return '#ca8a04'; // Jaune pour en route
                    case 'Livré':
                        return '#16a34a'; // Vert pour livré
                    default:
                        return '#6b7280';
                }
            } else {
                return mission.startMission ? '#ea580c' : '#6b7280';
            }
        }
        
        // Pour les transports
        if (mission.type === 'Transport') {
            if (mission.payedDriverConfirmation) {
                return '#16a34a'; // Vert pour terminé
            } else if (mission.startMission) {
                return '#ea580c'; // Orange pour en cours
            } else {
                return '#6b7280'; // Gris pour en attente
            }
        }
        
        // Fallback général
        return mission.startMission ? '#ea580c' : '#6b7280';
    };
    
    // Fonction pour obtenir la couleur de fond du statut
    const getMissionStatusBgColor = (mission) => {
        if (!mission) return '#f9fafb';
        
        if (mission.cancelled) {
            return '#fef2f2'; // Rouge clair pour annulé
        }
        
        if (mission.type === 'Livraison' && mission.livraisonStatus) {
            switch (mission.livraisonStatus) {
                case 'Accepté':
                    return '#eff6ff'; // Bleu clair
                case 'Prise en charge':
                    return '#fff7ed'; // Orange clair
                case 'En route':
                    return '#fffbeb'; // Jaune clair
                case 'Livré':
                    return '#f0fdf4'; // Vert clair
                default:
                    return '#f9fafb';
            }
        }
        
        if (mission.payedDriverConfirmation) {
            return '#f0fdf4'; // Vert clair pour terminé
        } else if (mission.startMission) {
            return '#fff7ed'; // Orange clair pour en cours
        } else {
            return '#f9fafb'; // Gris clair pour en attente
        }
    };
    
    // Fonction pour obtenir la couleur de bordure du statut
    const getMissionStatusBorderColor = (mission) => {
        if (!mission) return '#e5e7eb';
        
        if (mission.cancelled) {
            return '#fecaca'; // Rouge clair pour annulé
        }
        
        if (mission.type === 'Livraison' && mission.livraisonStatus) {
            switch (mission.livraisonStatus) {
                case 'Accepté':
                    return '#bfdbfe'; // Bleu clair
                case 'Prise en charge':
                    return '#fed7aa'; // Orange clair
                case 'En route':
                    return '#fde68a'; // Jaune clair
                case 'Livré':
                    return '#bbf7d0'; // Vert clair
                default:
                    return '#e5e7eb';
            }
        }
        
        if (mission.payedDriverConfirmation) {
            return '#bbf7d0'; // Vert clair pour terminé
        } else if (mission.startMission) {
            return '#fed7aa'; // Orange clair pour en cours
        } else {
            return '#e5e7eb'; // Gris clair pour en attente
        }
    };

    return (
        <div className="map-wrap">
            {/* Div flottante compacte - Informations essentielles du chauffeur */}
            {(driverData || missionData) && (
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    zIndex: 1000,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '16px',
                    padding: '12px 16px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    minWidth: '220px',
                    maxWidth: '280px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                }} onClick={() => setShowDetailsModal(true)}>
                    {/* Ligne 1: Avatar + Nom + Statut */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        marginBottom: '8px'
                    }}>
                        {/* Avatar avec initiale */}
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>
                            {driverData?.name ? driverData.name.charAt(0).toUpperCase() : '?'}
                        </div>

                        <div style={{ flex: 1, minWidth: 0 }}>
                            {/* Nom du chauffeur */}
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#2c3e50',
                                marginBottom: '2px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {driverData?.name || 'Chauffeur'}
                            </div>

                            {/* Statut en ligne */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                fontSize: '12px'
                            }}>
                                <div style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: isWebSocketConnected ? '#27ae60' : '#e74c3c'
                                }} />
                                <span style={{
                                    color: isWebSocketConnected ? '#27ae60' : '#e74c3c',
                                    fontWeight: '500'
                                }}>
                                    {isWebSocketConnected ? 'En ligne' : 'Hors ligne'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Ligne 2: Type de véhicule + Numéro de course */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontSize: '12px',
                        color: '#7f8c8d'
                    }}>
                        <span style={{
                            background: 'rgba(52, 152, 219, 0.1)',
                            color: '#3498db',
                            padding: '4px 8px',
                            borderRadius: '8px',
                            fontWeight: '500'
                        }}>
                            {driverData?.vehicleType || 'Véhicule'}
                        </span>

                        {missionData?.orderId && (
                            <span style={{
                                background: 'rgba(231, 76, 60, 0.1)',
                                color: '#e74c3c',
                                padding: '4px 8px',
                                borderRadius: '8px',
                                fontWeight: '500'
                            }}>
                                #{missionData.orderId}
                            </span>
                        )}
                    </div>

                    {/* Indicateur "Cliquer pour détails" */}
                    <div style={{
                        textAlign: 'center',
                        marginTop: '8px',
                        fontSize: '10px',
                        color: '#95a5a6',
                        fontStyle: 'italic'
                    }}>
                        Cliquer pour plus de détails
                    </div>
                </div>
            )}

            {/* Modal de détails complets */}
            {showDetailsModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 2000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }} onClick={() => setShowDetailsModal(false)}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        padding: '24px',
                        maxWidth: '400px',
                        width: '100%',
                        maxHeight: '80vh',
                        overflowY: 'auto',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }} onClick={(e) => e.stopPropagation()}>
                        {/* En-tête du modal */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #ecf0f1'
                        }}>
                            <h2 style={{
                                margin: 0,
                                fontSize: '20px',
                                color: '#2c3e50',
                                fontWeight: '600'
                            }}>
                                Détails du trajet
                            </h2>
                            <button style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                color: '#95a5a6',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '50%',
                                width: '32px',
                                height: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }} onClick={() => setShowDetailsModal(false)}>
                                ×
                            </button>
                        </div>

                        {/* Informations du chauffeur */}
                        {driverData && (
                            <div style={{ marginBottom: '24px' }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '8px',
                                        backgroundColor: '#10b981',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                            <circle cx="12" cy="7" r="4" />
                                        </svg>
                                    </div>
                                    <h3 style={{
                                        margin: 0,
                                        fontSize: '16px',
                                        color: '#111827',
                                        fontWeight: '600'
                                    }}>
                                        Informations du chauffeur
                                    </h3>
                                </div>

                                <div style={{
                                    padding: '16px',
                                    backgroundColor: '#f9fafb',
                                    borderRadius: '12px',
                                    border: '1px solid #e5e7eb'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px'
                                    }}>
                                        <div style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '12px',
                                            backgroundColor: '#3b82f6',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: '18px',
                                            fontWeight: '600'
                                        }}>
                                            {driverData.name ? driverData.name.charAt(0).toUpperCase() : '?'}
                                        </div>

                                        <div style={{ flex: 1 }}>
                                            <div style={{
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                color: '#111827',
                                                marginBottom: '6px'
                                            }}>
                                                {driverData.name || 'Nom non disponible'}
                                            </div>

                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginBottom: '8px'
                                            }}>
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                                </svg>
                                                <span style={{
                                                    fontSize: '14px',
                                                    color: '#6b7280'
                                                }}>
                                                    {driverData.phone || 'Téléphone non disponible'}
                                                </span>
                                            </div>

                                            {driverData.vehicleType && (
                                                <div style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    fontSize: '12px',
                                                    color: '#059669',
                                                    backgroundColor: '#d1fae5',
                                                    padding: '4px 8px',
                                                    borderRadius: '6px'
                                                }}>
                                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                        <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                        <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
                                                    </svg>
                                                    {driverData.vehicleType}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Informations de la mission */}
                        {missionData && (
                            <div style={{ marginBottom: '24px' }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '8px',
                                        backgroundColor: '#8b5cf6',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                            <circle cx="12" cy="10" r="3" />
                                        </svg>
                                    </div>
                                    <h3 style={{
                                        margin: 0,
                                        fontSize: '16px',
                                        color: '#111827',
                                        fontWeight: '600'
                                    }}>
                                        Détails du trajet
                                    </h3>
                                </div>

                                {/* Type de mission */}
                                {missionData.type && (
                                    <div style={{
                                        marginBottom: '16px',
                                        padding: '12px 16px',
                                        backgroundColor: missionData.type === 'Transport' ? '#dbeafe' : '#fef3c7',
                                        borderRadius: '10px',
                                        border: `1px solid ${missionData.type === 'Transport' ? '#93c5fd' : '#fcd34d'}`,
                                        textAlign: 'center'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: missionData.type === 'Transport' ? '#1e40af' : '#92400e'
                                        }}>
                                            {missionData.type === 'Transport' ? (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                    <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                    <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
                                                </svg>
                                            ) : (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <rect x="1" y="3" width="15" height="13" />
                                                    <path d="m16 8 2 2-2 2" />
                                                    <path d="M21 12H7" />
                                                </svg>
                                            )}
                                            {missionData.type === 'Transport' ? 'Transport' : 'Livraison'}
                                        </div>
                                    </div>
                                )}

                                {/* Adresses */}
                                <div style={{ marginBottom: '16px' }}>
                                    {/* Départ */}
                                    <div style={{
                                        padding: '12px',
                                        backgroundColor: '#f0fdf4',
                                        borderRadius: '10px',
                                        border: '1px solid #bbf7d0',
                                        marginBottom: '12px'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginBottom: '6px'
                                        }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#22c55e',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <div style={{
                                                    width: '8px',
                                                    height: '8px',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'white'
                                                }} />
                                            </div>
                                            <span style={{
                                                fontSize: '11px',
                                                color: '#166534',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Point de départ
                                            </span>
                                        </div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#166534',
                                            lineHeight: '1.4',
                                            paddingLeft: '28px'
                                        }}>
                                            {missionData.pickupLocation || missionData.pickupAddress || 'Adresse de départ non disponible'}
                                        </div>
                                    </div>

                                    {/* Destination */}
                                    <div style={{
                                        padding: '12px',
                                        backgroundColor: '#fef2f2',
                                        borderRadius: '10px',
                                        border: '1px solid #fecaca'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginBottom: '6px'
                                        }}>
                                            <div style={{
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ef4444',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <div style={{
                                                    width: '8px',
                                                    height: '8px',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'white'
                                                }} />
                                            </div>
                                            <span style={{
                                                fontSize: '11px',
                                                color: '#991b1b',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Destination
                                            </span>
                                        </div>
                                        <div style={{
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#991b1b',
                                            lineHeight: '1.4',
                                            paddingLeft: '28px'
                                        }}>
                                            {missionData.dropoffLocation || missionData.deliveredAddress || 'Adresse de destination non disponible'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Statut et informations temporelles */}
                        <div style={{
                            padding: '16px',
                            backgroundColor: getMissionStatusBgColor(missionData),
                            borderRadius: '12px',
                            border: `1px solid ${getMissionStatusBorderColor(missionData)}`,
                            marginBottom: '16px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                gap: '12px'
                            }}>
                                <div>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        marginBottom: '6px'
                                    }}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={getMissionStatusColor(missionData)} strokeWidth="2">
                                            <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                                        </svg>
                                        <span style={{
                                            fontSize: '11px',
                                            color: getMissionStatusColor(missionData),
                                            fontWeight: '600',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}>
                                            Statut
                                        </span>
                                    </div>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: getMissionStatusColor(missionData)
                                    }}>
                                        {getMissionStatusText(missionData)}
                                    </div>
                                </div>
                                {missionData?.createdAt && (
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={{
                                            fontSize: '11px',
                                            color: '#6b7280',
                                            lineHeight: '1.3'
                                        }}>
                                            Créée le {formatDate(missionData.createdAt)}
                                        </div>
                                        <div style={{
                                            fontSize: '11px',
                                            color: '#6b7280'
                                        }}>
                                            à {formatTime(missionData.createdAt)}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Informations supplémentaires si disponibles */}
                            {(missionData?.duration || missionData?.nbresPassager) && (
                                <div style={{
                                    marginTop: '12px',
                                    paddingTop: '12px',
                                    borderTop: '1px solid rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    gap: '16px',
                                    flexWrap: 'wrap'
                                }}>
                                    {missionData.duration && (
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '12px',
                                            color: '#6b7280'
                                        }}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12,6 12,12 16,14" />
                                            </svg>
                                            Durée: {missionData.duration}
                                        </div>
                                    )}
                                    {missionData.nbresPassager && (
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '12px',
                                            color: '#6b7280'
                                        }}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                                <circle cx="9" cy="7" r="4" />
                                                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                            </svg>
                                            Passagers: {missionData.nbresPassager}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* Dernière mise à jour de position */}
                        {/* {lastUpdate && (
                            <div style={{
                                padding: '16px',
                                backgroundColor: '#eff6ff',
                                borderRadius: '12px',
                                border: '1px solid #bfdbfe'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    flexWrap: window.innerWidth < 400 ? 'wrap' : 'nowrap',
                                    gap: '12px'
                                }}>
                                    <div>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginBottom: '6px'
                                        }}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12,6 12,12 16,14" />
                                            </svg>
                                            <span style={{
                                                fontSize: '11px',
                                                color: '#1d4ed8',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Dernière position
                                            </span>
                                        </div>
                                        <div style={{
                                            fontSize: '14px',
                                            color: '#1e40af',
                                            fontWeight: '500'
                                        }}>
                                            Mise à jour à {formatTime(lastUpdate)}
                                        </div>
                                        {location.name && (
                                            <div style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                fontSize: '12px',
                                                color: '#1d4ed8',
                                                backgroundColor: '#dbeafe',
                                                padding: '4px 8px',
                                                borderRadius: '6px',
                                                marginTop: '6px'
                                            }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                    <circle cx="12" cy="7" r="4" />
                                                </svg>
                                                {location.name}
                                            </div>
                                        )}
                                    </div>
                                    <div style={{
                                        width: '10px',
                                        height: '10px',
                                        borderRadius: '50%',
                                        backgroundColor: '#22c55e',
                                        boxShadow: '0 0 0 4px rgba(34, 197, 94, 0.2)',
                                        animation: 'pulse 2s infinite'
                                    }} />
                                </div>
                            </div>
                        )} */}
                    </div>
                </div>
            )}

            {/* Contrôles de la carte */}
            <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
                {/* Croix de centrage */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                    height: 50,
                    width: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <PlusOutlined style={{ color: colors.black, fontSize: '12px' }} />
                </div>

                {/* Contrôles mobiles - Position responsive */}
                <div style={{
                    position: 'absolute',
                    bottom: window.innerWidth < 768 ? '15px' : '20px',
                    right: window.innerWidth < 768 ? '15px' : '20px',
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    alignItems: 'flex-end'
                }}>
                    {/* Bouton de centrage sur le chauffeur */}
                    {location.latitude && location.longitude && (
                        <div style={{
                            backgroundColor: '#3498db',
                            height: window.innerWidth < 480 ? 45 : 50,
                            width: window.innerWidth < 480 ? 45 : 50,
                            borderRadius: '50%',
                            boxShadow: '0 4px 20px rgba(52, 152, 219, 0.3)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }} onClick={() => {
                            if (map.current && location.latitude && location.longitude) {
                                map.current.setView([location.latitude, location.longitude], 15);
                            }
                        }}>
                            <FaCrosshairs style={{
                                color: 'white',
                                fontSize: window.innerWidth < 480 ? '18px' : '20px'
                            }} />
                        </div>
                    )}

                    {/* Bouton d'alerte */}
                    {showMarker ? (
                        <div style={{
                            backgroundColor: 'white',
                            height: window.innerWidth < 480 ? 45 : 50,
                            width: window.innerWidth < 480 ? 45 : 50,
                            borderRadius: '50%',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }} onClick={cancelShowMarker}>
                            <AlertFilled style={{
                                color: colors.secondary,
                                fontSize: window.innerWidth < 480 ? '18px' : '20px'
                            }} />
                        </div>
                    ) : (
                        <div style={{
                            backgroundColor: 'white',
                            height: window.innerWidth < 480 ? 45 : 50,
                            width: window.innerWidth < 480 ? 45 : 50,
                            borderRadius: '50%',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }} onClick={showMarkerFunc}>
                            <AlertOutlined style={{
                                color: colors.black,
                                fontSize: window.innerWidth < 480 ? '18px' : '20px'
                            }} />
                        </div>
                    )}
                </div>
            </div>

            <div ref={mapContainer} className="map" style={{ zIndex: 0 }} />
        </div>
    )
}

export default DriverShareMap;
